import styled from 'styled-components';
import LateTime from '../common/Icons/LateTime';
import { mediaQueries } from '../common/MediaQueries/mediaQueries';

export const LateSubmissionIcon = styled(LateTime)`
  margin-left: 5px;
`;
export const FileRendereContainer = styled.div`
  border-radius: 6px;
  border: ${props =>
    !props.isAttachmentConversionCompleted ? 'solid 2px #e9e9e9' : 'none'};
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: baseline;
`;
export const DropdownArea = styled.div`
  border-top: ${({ hide }) =>
    hide ? 'none' : '2px solid var(--light-gray-border)'};
`;
export const RemoveAttachmentButton = styled.div`
  cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
`;
export const SubmittedOn = styled.div`
  font-size: 16px;
  font-family: var(--font-family-signika);
  font-weight: 300;
  line-height: 20px;
  display: flex;
  align-items: flex-start;
  word-wrap: break-word;
  color: var(--river-bed);

  ${mediaQueries('screen-medium', 'min')`
      justify-content: flex-start;
      align-items: center;
  `};

  span {
    margin-left: 3px;
    margin-right: 3px;
  }
`;

export const SubmittedRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const FileName = styled.div`
  font-family: var(--font-family-serif);
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: var(--river-bed);
  word-wrap: break-word;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
